import * as ReduxToolkit from "@reduxjs/toolkit";
import { DriversRow, WeeklyReportsRow } from "../../api";
import { yesterday } from "../../utils/time";

export interface WeeklyReportState {
    selectedStartDate: string;
    selectedEndDate: string;
    selectedOfficeId: number | null;
    selectedDriver: DriversRow | null;
    weeklyReports: WeeklyReportsRow[] | null;
    needUpdateFlag: boolean;
    viewingUnFeedbackedOnly: boolean;
}

export const initWeeklyReportState = (): WeeklyReportState => {
    return {
        selectedStartDate: yesterday(),
        selectedEndDate: yesterday(),
        selectedOfficeId: null,
        selectedDriver: null,
        weeklyReports: null,
        needUpdateFlag: false,
        viewingUnFeedbackedOnly: false,
    } as WeeklyReportState;
};

export const weeklyReportsSlice = ReduxToolkit.createSlice({
    name: "weekly_report_slice",
    initialState: initWeeklyReportState() as WeeklyReportState,
    reducers: {
        resetState: (state) => {
            state = initWeeklyReportState();
            return state;
        },
        setViewingUnfeedbackedOnly: (
            state,
            action: ReduxToolkit.PayloadAction<boolean>
        ) => {
            state.viewingUnFeedbackedOnly = action.payload;
            return state;
        },
        setSelectedDriver: (
            state,
            action: ReduxToolkit.PayloadAction<DriversRow | null>
        ) => {
            state.selectedDriver = action.payload;
            return state;
        },
        setSelectedOfficeId: (
            state,
            action: ReduxToolkit.PayloadAction<number | null>
        ) => {
            state.selectedOfficeId = action.payload;
            return state;
        },
        setWeeklyReports: (
            state,
            action: ReduxToolkit.PayloadAction<WeeklyReportsRow[] | null>
        ) => {
            state.weeklyReports = action.payload;
            return state;
        },
        setStartDate: (state, action: ReduxToolkit.PayloadAction<string>) => {
            state.selectedStartDate = action.payload;
            return state;
        },
        setEndDate: (state, action: ReduxToolkit.PayloadAction<string>) => {
            state.selectedEndDate = action.payload;
            return state;
        },
        setNeedUpdateFlag: (
            state,
            action: ReduxToolkit.PayloadAction<boolean>
        ) => {
            state.needUpdateFlag = action.payload;
            return state;
        },
    },
});
